
import nigeria from '../../../../../assets/img/country_flags/nigeria.svg';
import dominican from '../../../../../assets/img/country_flags/dominican_republic.svg';
import costa_rica from '../../../../../assets/img/country_flags/costa_rica.svg';
import colombia from '../../../../../assets/img/country_flags/colombia.svg';
import brazil from '../../../../../assets/img/country_flags/brazil.svg';
import egypt from '../../../../../assets/img/country_flags/egypt.svg';
import ghana from '../../../../../assets/img/country_flags/ghana.svg';
import bangladesh from '../../../../../assets/img/country_flags/bangladesh.svg';
import india from '../../../../../assets/img/country_flags/india.svg';
import turkey from '../../../../../assets/img/country_flags/turkey.svg';
import kenya from '../../../../../assets/img/country_flags/kenya.svg';
import ukraine from '../../../../../assets/img/country_flags/ukraine.svg';
import serbia from '../../../../../assets/img/country_flags/serbia.svg';
import pakistan from '../../../../../assets/img/country_flags/pakistan.svg';
import palestine from '../../../../../assets/img/country_flags/palestine.svg';

export const ResumeUploadAction = {
  LOADING: 'NEW_LOADING',
  UPLOAD_RESUME_SUCCESS: 'NEW_UPLOAD_RESUME_SUCCESS',
  UPLOAD_RESUME_FAIL: 'NEW_UPLOAD_RESUME_FAIL',
  FETCH_RESUME_INFO_SUCCESS: 'NEW_FETCH_RESUME_INFO_SUCCESS',
  FETCH_RESUME_INFO_FAIL: 'NEW_FETCH_RESUME_INFO_FAIL',
  FETCH_RESUME_PARSED_DATA_SUCCESS: 'NEW_FETCH_RESUME_PARSED_DATA_SUCCESS',
  FETCH_RESUME_PARSED_DATA_FAIL: 'NEW_FETCH_RESUME_PARSED_DATA_FAIL',
  RESUME_MODAL_SKIP: 'NEW_RESUME_MODAL_SKIP',
  UPDATE_LINKEDIN_URL: "UPDATE_LINKEDIN_URL",
  SHOW_LINKEDIN_SUCCESS_BANNER: "SHOW_LINKEDIN_SUCCESS_BANNER",
  SHOW_RESUME_SUCCESS_BANNER: "SHOW_RESUME_SUCCESS_BANNER",
  UPDATE_LINKEDIN_ERROR: "UPDATE_LINKEDIN_ERROR",
  TOGGLE_DISABLED_FIELDS: 'TOGGLE_DISABLED_FIELDS',
  UPDATE_RESUME_UPLOAD_MODAL_STATE: 'UPDATE_RESUME_UPLOAD_MODAL_STATE',
  RESET_STATE: 'RESET_STATE',
  UPDATE_RESUME_STATE_DATA: 'UPDATE_RESUME_STATE_DATA'
};

export const countryFlags = {
  'dominican republic': dominican,
  'costa rica': costa_rica,
  'colombia': colombia,
  'brazil': brazil,
  'egypt': egypt,
  'ghana': ghana,
  'nigeria': nigeria,
  'bangladesh': bangladesh,
  'india': india,
  'turkey': turkey,
  'kenya': kenya,
  'ukraine': ukraine,
  'serbia': serbia,
  'pakistan': pakistan,
  'palestine': palestine
}
